// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__2b6EW","evaluation-result-wrapper":"evaluation-result-wrapper__3WuSg"};